import { render } from "./powerOn.vue?vue&type=template&id=29c9e588&scoped=true"
import script from "./powerOn.vue?vue&type=script&lang=js"
export * from "./powerOn.vue?vue&type=script&lang=js"

import "./powerOn.vue?vue&type=style&index=0&id=29c9e588&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c9e588"]])

export default __exports__